"use client"

import { FileOutput } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileOutputIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileOutputIcon = component(Icon)({ as: FileOutput })
